export interface GallerySlide {
  title: string
  src: string
  alt: string
}

const sixMoments: GallerySlide = {
  title: 'One Exchange. Six Coaching Moments.',
  src: 'https://cdn.magicpatterns.com/uploads/1o8X953ZtQzho2BfESJhcM/Captura_de_pantalla_2026-10-03_210112.png',
  alt: 'Coaching page showing a single striking exchange broken into six teachable elements: range, guard, target, reaction, angle and reset',
}

const combinationChain: GallerySlide = {
  title: 'Combination Chain 01 — Jab → Cross → Low Kick → Exit',
  src: 'https://cdn.magicpatterns.com/uploads/5GWt2XnPWRFFMU6bsZQ2HA/Captura_de_pantalla_2026-10-03_210050.png',
  alt: 'Five-frame photo sequence of a jab, cross, low kick and 45-degree exit with coaching notes and three progression levels',
}

const decisionMap: GallerySlide = {
  title: 'MMA Combination Decision Map',
  src: 'https://cdn.magicpatterns.com/uploads/3FUxsRX3JB1J29nvw38wxW/Captura_de_pantalla_2026-10-03_210025.png',
  alt: 'Decision map showing five opponent reactions and how the striker should adapt the combination for each one',
}

const targetMap: GallerySlide = {
  title: 'Body-Head Target Map',
  src: 'https://cdn.magicpatterns.com/uploads/oLLarD2jsFkrYr3c2ixTJV/Captura_de_pantalla_2026-10-03_205946.png',
  alt: 'Front and side view of an athlete with head, body, centerline and side target zones marked and explained',
}

const strikingMap: GallerySlide = {
  title: 'The Complete MMA Striking Map — 8 Phases',
  src: 'https://cdn.magicpatterns.com/uploads/n27p1N7udE3Fvx71XJQCRB/Captura_de_pantalla_2026-10-03_205924.png',
  alt: 'Eight-phase striking map from stance and range through strike, reaction, defense, counter, angle and reset',
}

export const insideSlides: GallerySlide[] = [
  sixMoments,
  combinationChain,
  decisionMap,
  targetMap,
  strikingMap,
]

export const gymSlides: GallerySlide[] = [
  combinationChain,
  strikingMap,
  targetMap,
  sixMoments,
  decisionMap,
]

export const sessionSlides: GallerySlide[] = [
  strikingMap,
  decisionMap,
  sixMoments,
  combinationChain,
  targetMap,
]
